<template>
  <div class="container goosList">
    <van-nav-bar
      title="积分商城"
      left-text
      fixed
      left-arrow
      @click-left="$router.go(-1)"
    />
    <h2 class="pName">全部</h2>
    <van-empty description="什么都没有~" v-show="isEmpty" />
    <van-list
      style="margin-top: -5px"
      v-model="loading"
      :finished="finished"
      :finished-text="finishText"
      @load="onLoad"
      :immediate-check="false"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :offset="30"
    >
      <div class="pageList">
        <transition-group
          v-bind:css="false"
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-on:after-enter="afterEnter"
        >
          <div
            class="padding15 pageListItem"
            v-for="(item, index) in dataList"
            :key="item.id"
            :data-delay="index * 20"
            data-y="100%"
            @click="handleDetails(item.id)"
          >
            <div class="pointsPicture">
              <van-image fit="cover" :src="item.mainImgUrl" />
            </div>
            <div class="actText">
              <van-row
                type="flex"
                justify="space-between"
                class="colorBlack goodsName"
              >
                <van-col span="24" class="van-ellipsis3 fz16 marginBottom3">{{
                  item.name
                }}</van-col>
              </van-row>
              <van-row
                type="flex"
                justify="space-between"
                class="marginTop3 points"
              >
                <van-col span="24" class="van-ellipsis">
                  <i
                    class="iconfont icon-jifen marginRight5"
                    style="color: #ccc"
                  />
                  <span class="num">{{ item.integral }}分</span>
                </van-col>
                <div class="arrowIcon">
                  <van-icon name="arrow" />
                </div>
              </van-row>
            </div>
          </div>
        </transition-group>
      </div>
    </van-list>
    <tab-bar></tab-bar>
    <div class="blankHeight"></div>
  </div>
</template>

<script>
import tabBar from "@/view/component/tabBar";
import { goodsList } from "@/api/data";
export default {
  components: { tabBar },
  data() {
    return {
      dataList: [],
      pageInfo: {
        page: 1,
        limit: 10,
      },
      loading: false,
      error: false,
      finished: false,
      finishText: "",
      isEmpty: false,
    };
  },
  created() {
    this.getList();
  },

  methods: {
    beforeEnter(dom) {
      let { x = 0, y = 0, s = 1, opacity = 0 } = dom.dataset;
      dom.style.cssText = `transition: .2s;opacity: ${opacity};transform: scale(${s}) translateX(${x}) translateY(${y});`;
    },
    enter(dom, done) {
      let delay = dom.dataset.delay;
      setTimeout(function () {
        dom.style.cssText = `transition: .2s;opacity: 1;transform: scale(1) translateX(0) translateY(0);`;
        //监听 transitionend 事件
        var transitionend = window.ontransitionend
          ? "transitionend"
          : "webkitTransitionEnd";
        dom.addEventListener(transitionend, function onEnd() {
          dom.removeEventListener(transitionend, onEnd);
          done(); //调用done() 告诉vue动画已完成，以触发 afterEnter 钩子
        });
      }, delay);
    },
    afterEnter(dom) {
      dom.style.cssText = "";
    },

    getList(type) {
      let _this = this;
      let obj = Object.assign({}, _this.pageInfo, { checkFlag: 2 });
       this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
    });
      goodsList(obj)
        .then((res) => {
          if (res) {
            if (res.data.totalCount == 0) {
              _this.isEmpty = true;
            } else {
              _this.isEmpty = false;
            }
            if (!res.data.list) {
              _this.finished = true;
              return;
            }
            if (type == "reset") {
              _this.dataList = [];
              _this.finishText = "";
            }
            setTimeout(() => {
              _this.dataList.push(...res.data.list);
              _this.loading = false;
              if (
                res.data.currPage === res.data.totalPage &&
                res.data.totalCount > 0
              ) {
                _this.finished = true;
                _this.finishText = "亲，已经到底啦";
                return;
              }
            }, 300);
          } else {
            _this.isEmpty = true;
            _this.dataList = [];
            _this.finishText = "";
          }
          _this.$toast.clear();
        })
        .catch(() => {
          _this.$toast.clear();
        });
    },
    onLoad() {
      this.pageInfo.page++;
      this.getList();
    },
    handleDetails(id) {
      this.$router.push({ name: "pointsDetail", query: { id: id } });
    },
  },
};
</script>

<style lang='less'>
.pName {
  padding: 0 0 0 15px;
  color: #000;
  font-size: 16px;
  font-weight: normal;
}
.pointsPicture {
  width: 90px;
  height: 90px;
  margin-right: 10px;
  border-radius: 15px;
  overflow: hidden;
  .van-image {
    width: 100%;
    height: 100%;
  }
}
.goosList {
  .goodsName {
    height: 68px;
  }
  .arrowIcon {
    bottom: 0 !important;
    top: auto !important;
  }
}
</style>